module.exports = __webpack_public_path__ + "img/NW06.dc6e9917.jpg";